export { default } from "./getIsEditorsNote";
